import type { TechnologyCategoryDTO } from "../types/dto";
import type {
    GroupedTechnologies,
    GroupedTechnologiesCategoryMap,
    Technology,
    TechnologyCategory,
    TechnologySubCategory,
} from "../types/model";

export function groupTechnologiesByType(categoriesDTO: readonly TechnologyCategoryDTO[]): GroupedTechnologies {
    const categories: TechnologyCategory[] = [];
    const subCategories: TechnologySubCategory[] = [];
    const technologies: Technology[] = [];

    categoriesDTO.forEach((categoryDTO) => {
        const techCount = categoryDTO.categories.reduce(
            (count, subCategory) => count + subCategory.technologies.length,
            0,
        );

        categories.push({ name: categoryDTO.name, techCount });

        categoryDTO.categories.forEach((subCategoryDTO) => {
            subCategoryDTO.technologies.forEach((technologyDTO) => {
                technologies.push({ ...technologyDTO, secondaryName: subCategoryDTO.name });
            });

            if (subCategoryDTO.name === categoryDTO.name) {
                return;
            }

            subCategories.push({
                name: subCategoryDTO.name,
                secondaryName: categoryDTO.name,
                techCount: subCategoryDTO.technologies.length,
            });
        });
    });

    return { technologies, subCategories, categories };
}

export function toGroupedTechnologiesCategoryMap(grouped: GroupedTechnologies): GroupedTechnologiesCategoryMap {
    return {
        categories: new Set(grouped.categories.map(({ name }) => name)),
        subCategories: new Map(grouped.subCategories.map(({ name, secondaryName }) => [name, secondaryName])),
        technologies: new Map(grouped.technologies.map(({ name, secondaryName }) => [name, secondaryName])),
    };
}
